import { ButtonModal, ControlledLine } from "#components";
import { useTranslation } from "#hooks";
import { LinkIcon, TextAside } from "#ui";
import React from "react";

export const Goals: React.FC = () => {
  const { t: tHome } = useTranslation("home");
  const { copytext, link } = tHome("goals");
  return (
    <ControlledLine source={copytext} modal={link.modal}>
      {({ targetRef, render }) => (
        <TextAside content={render} withLine>
          <ButtonModal list={link.modal}>
            {({ onClick }) => <LinkIcon targetRef={targetRef} onClick={onClick} {...link} />}
          </ButtonModal>
        </TextAside>
      )}
    </ControlledLine>
  );
};
